__turbopack_context__.v({
  "backBtn": "STPrivacyPolicy-module__ElMxia__backBtn",
});
